/*
 * @Auth: linjituan
 * @Date: 2023-01-11 18:52:46
 * @LastEditors: linjituan linjituan@revolution.com
 * @LastEditTime: 2023-09-12 16:15:07
 */
import { getArticleTime } from './utils'

function getTemp(opt) {
  const on = '<script>'
  const off = `/script>`
  const articleTime = getArticleTime(opt)
  const bc = `<!doctype html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=no"/>
<title>于万智驾官网_无人驾驶环卫车_清扫机器人_无人环卫_智慧环卫云控平台</title> 
<meta name="keywords" content="环卫自动驾驶,自动驾驶环卫车,自动驾驶清扫车,智能环卫车,智能驾驶环卫车,无人驾驶环卫车,无人环卫车,无人驾驶清洁车,无人清扫车,无人驾驶垃圾车,无人垃圾车,无人驾驶扫路车,无人扫路车,无人驾驶扫地车,无人扫地车,清扫机器人,清洁机器人,无人驾驶清洁车,无人清洁车,环卫无人车,无人环卫,环卫无人驾驶,智慧环卫运控平台,智慧环卫平台,环卫科技公司,智慧环卫解决方案,智慧环卫装备,无人环卫装备,无人驾驶环卫装备,新型环卫装备,自动驾驶环卫装备">
<meta name="Description" content="环卫自动驾驶,自动驾驶环卫车,自动驾驶清扫车,智能环卫车,智能驾驶环卫车,无人驾驶环卫车,无人环卫车,无人驾驶清洁车,无人清扫车,无人驾驶垃圾车,无人垃圾车,无人驾驶扫路车,无人扫路车,无人驾驶扫地车,无人扫地车,清扫机器人,清洁机器人,无人驾驶清洁车,无人清洁车,环卫无人车,无人环卫,环卫无人驾驶,智慧环卫运控平台,智慧环卫平台,环卫科技公司,智慧环卫解决方案,智慧环卫装备,无人环卫装备,无人驾驶环卫装备,新型环卫装备,自动驾驶环卫装备">
<link rel="icon" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAArCAYAAAD7YZFOAAAIGUlEQVRYhc1YeZBUxR3++p1zwuzFAnJYKoajOI1IYSCBhAiKQStgwCA7Q0KlONZUkIimLIGgkrKAiqihAlL7qHCYEoIEq8BEIIZgOKySI2ExAWQhhl2X3VnZnePNe92d6tl58HZ3ZnewYCrfP9Pd79c9X3/96+7fr/H/DDLs8QM9Aw3eDUxmjwqetk5hK4xTjaVpU40SJvNzhJGPvyyP7yitCR4+tWtiba45zTtsTPSo2K8pgCaD6zKIaPeprd91GVBlcAL8rXcAr0wrC+/LNRa576FDb3pjygJbbSXjkCMETbbKQoJcmqTOkPTYVJS5xPfFupm7A436jpqNU6PuAX9xpur7zS1kR1fkNAlElQCfhr21McytvCvcYcKSnlD6OhUzYEUVU17EVNb7yrjaHl/eEQsSKg1SE8pU/Zq6QJBKz4iRyR5T+W2iKHW+9Lmd6/0rfj/IGeOVwZGd5QFsE8Qow1UO1EkEsVzqWBRTylWc2vSZcU8H5cZMOLxQsaQ3MsotOnLwwTc7c8P+894rsvx0omLKEarTh5M+O92e8lnbGCUvx5b9oFrU5x8zygaXQvYpMOM2dNNGDw/BkCYLU4u9mOUopwolW3/PNiQw9kf9wtdXIi352PF//6PwOS7xF4/u/8bKzsi5UfTiO30li4RByApbbyXJZL6tuCZQ2X653Xj9gtGTcawPaXjMRQ4qwZZHSsNPtSHXr3KPv/c/iz8Gx8B4KDXm1K4JR/Ml6PSPlseWS5Q8Y+mUEJk3Jrz2s2xRxabO+hkXjRc0DSvdCsoMD0wuCx+7Tg6Z5ep1vugjW6MDCSMDjv9p3LmbISiQ9j2NbeGEj7I1Buahu0tb9Om1z860c/V5+4qxSyYuBSW88d2icKX4JjlGYhmOHHhwkBZX91ga/deIR/8y+2bJCX+LPT/rPtmWVqcbbDLti2DyNFlfdWeuPiEFq7irLjE85JRJtg6CGAHWJQPW+9GRDU91NvNcUF7fvBicrBEbTQLOhlSMb/xxuD6b+fb/Gqe8KoYK5TQJSRCMmhQKV0vZjE/s+dYWqrDBvkZPY8nxsg5bPB/YlRVrvR62VpQZ4QOjlG/O1Y8QnHdVPXEL/UVBydUhcwss/CrEHKgSfkUo5nCglHNM0TZWzUjNi7zT3s5muOKuKxJ8cPtcIaBzMuZm/iancm70fPVtJSrbo33FVl00EnEvAUqW7pwHmY8HJX/VTaWxoW9zWgVLp4OaLL5EqObYxlLkTFYSEnq1UzKeN7naYOLXIFhomoC2seoJ99LESpMnAg2eUVSnc2J+u69qygqT+B3iZmcKA9FYnHNyCZSsznXucY67XdWkT0UNcu1WN8QxwAk+c5oIwV7+k8jD2WyFwnXBRB8trvYmjFhI39epej4/cjHX+LvrjckmxV4tc87pwL+/UxK+F/kq126WOftkjpyLJpCTjBurzxq+uIVXFZfn24TscMr5bQh+Q2BCcNNnXi5ifbpjKweGuttlif/OKadVEMuRbQChRMgDOWreOMPdyi07beSt/IqhYVsQgoR7SjV8z6ZYaNroKa6t68QIWTUpVFHt1Ik4e2yb/NKnc1M0FHvB3IOGdOgWw2BRFgN5JDSV+W/4YDf1hvrFXuK+idDD25agV0e5LqGXO9h07lQQ7J1RHm7jy4rNsIEoPMRlDg8IYinAr7X+h18lsBgQzESxPgVcUxGyGEamvytAkgIeBfASgoQJ+PVWWxEJJ1m7SJgjKyjHu9X1mNH+W5tlSYKjRGtr4JZdIGWlCXa5y/OBJuN0Nx3LHykJ/yGbuQJLWgKFr/Mm5PSVEU+k4/r0zC0LkDRmNStcTZO0QYR6XgV1wtZZf4kQmBl1kgzwysJ/IFEGcDljRlp/NRnnghr+0RTHoaYEds8aGI7nmkdaAbEh+r/f5/mUz/6Zk9SIhEagpSjJa4c0tiY59MY5J5z7/DX481VJhOxmCteWdEImKzkHIuAsvdT9JarS+U5qeK0swWpG1MvI+LqUko70SOrjvkoYdbPI6jtDZuwfyBS2jHDMjHVP0ZqRX8hyxvfkZhWhWl+UEr5ULbGqbifJTh172OMHH2gpSay78PW60W5ywateLhIaW2OfJAOppbSy4oOCk0Mmw4r2brmUJia3JSeSGZEr2Ao9opnK08mf//D4rSTX5fXV1KtF7spGAhmTDFjHlN9sfreoqururuxvGbn2SPmsP4PzZdm+cZVNkyScC24w1hS/ZZQVlFzmKLEbVk1fGfqPv0S2pa3Z7IqCbHGvAD4fvqNqccHIwXXxi1Sy+YWZs9VmdTAUvhttr1Uwhau6ijUT9lRdmnPImFsQcu0hclV7QcVjsiVN8so42WEyEvpEY3zTrA+rTojnsYKScyCOk5a5kRHNKTwhMXKhg4GF4ZRh/+Ljxt6ffmQMKyg5ByK/SH7u/ZoGPCM2eweOHJP9Kk6+dMbYmu3Z67aSQyZIPTk9svZcPblX4hCJdUuHP07hyZY4Pn3rU2NVOggtFDkH4vnhwNTIkj7F5C4QbM9h9lw/Py7uuWw8bTGzDZ+CJNXrR4frt3878mRQxnCVoMMbMKEoJsBrH0a3n/0kalx/yCloxv/a2PCptfeHpxBgkiXjRPvvcgoDbIp9R68aFQUn5+Dl+8MfLBsaHilrmA0FHR6q/SoG5UUudCVAZZDrAaLCpLyDxa6waEB4++U4+saA5QkK6phbDAeRT1SCzFubrbI1hJOrkk1m3Y4Q6b3Lxp1lXnwzylHtPLvmDXGRi7ffW00qJwD8D568UUtW6OjbAAAAAElFTkSuQmCC" type="image/x-icon"/>
<link rel="stylesheet" type="text/css" href="../style/index.css"  />
${on}
function divShow(){
document.getElementById("hmc").style.display="block";
document.getElementById("btnIcon").src ="../images/hiddenMenu.png";
document.body.style.overflow="hidden";
document.getElementById("btnhref").href ="javascript:divhidden()";
}
function divhidden(){
document.getElementById("hmc").style.display="none";
document.getElementById("btnIcon").src ="../images/showMenu.png";
document.body.style.overflow="auto";
document.getElementById("btnhref").href ="javascript:divShow()"; 
}
<${off}
<style>
.news-tap{
  max-width: 770px;
  margin: 0 auto;
  margin-top: 70px;
  padding: 70px 0 40px;
}
.news-tap h2{
  font-size: 30px;
  font-weight:lighter;

}
.news-tap p{
  margin-top: 15px;
  color: #A8A8A8;

}
.greenLine{
  width: 770px;
  margin: 0 auto;
}
.article-wrap{
  max-width: 770px;
  margin:30px auto;

}
.article-txt{
  line-height: 30px;
  font-size: 16px;
}
.article-txt img{
   width: 100%;
}
.article-wrap p {
  margin-top: 0;
  margin-bottom: 16px;
}
.article-wrap table {
  border-collapse: collapse;
  width: 100%;
}
.article-wrap table,
.article-wrap th,
.article-wrap td {
  font-size: 14px;
  border: 1px solid #eeeeee;
}
.article-wrap th,
.article-wrap td {
  padding-left: 15px;
  padding-right: 15px;
}
@media (max-width: 760px){
  .article-wrap{
      padding: 0 20px;
  }
  .news-tap h2, .news-tap p, .greenLine{
      margin-left: 20px;
      margin-right: 20px;
  }
}
</style>
${on}
var _hmt = _hmt || [];
(function() {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?dc344c0f02461ae0f40a58a7304ebb7c";
var s = document.getElementsByTagName("script")[0]; 
s.parentNode.insertBefore(hm, s);
})();
<${off}	
<script src="../js/jquery.min.js"><${off}
    ${on}
      $(document).ready(function () {
        window.currentMenu = "news.html";
        $("#header").load("../template/header.html");
      });
    <${off}
</head>

<body>
<!--头部导航-->
<div id="header"></div>

<div class="news-tap">
  <h2>${opt.noticeTitle}</h2>
  <p> ${articleTime}</p>
</div>
<div class="greenLine"><div style="width: 80px; height: 2px; background-color: #01AEA7;"></div></div>
<div class="article-wrap">
  <div class="article-txt">`
  const ac = `</div>

</div>
<div style="height: 40px;"></div>
<iframe
	class="footer-iframe"
	src="../template/footer.html"
	frameborder="0"
    ></iframe>
</body>
</html>`

  const source = `<p style="color: #CECECE; border-top: 1px solid #CECECE; padding: 30px 0;">来源：${opt.articleSource}</p>`
  return {
    header: bc,
    footer: ac,
    source: opt.articleSource && source
  }
}
export default getTemp
